import { useCallback, useEffect, useState } from "react";

import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { ArrowLeftIcon, ArrowRightIcon, LoaderIcon, XIcon } from "lucide-react";
import { FaTimes } from "react-icons/fa";
import { MdOutlineOpenInNew, MdWarningAmber } from "react-icons/md";
import InputMask from "react-input-mask";

import { REGEXP_ONLY_DIGITS_AND_CHARS } from "input-otp";
import { toast } from "react-toastify";
import { config } from "../../Config";
import { cn } from "../../lib/utils";
import {
  listDistribuidoras,
  obterPreCadastroPorTokenClaro,
  requestOtp,
  sendNextStep,
  simularEconomia,
  verifyOtp,
  consultaCreditScore
} from "../../page/api/simulador";
import AppButton from "../button/AppButton";
import { InputOTP, InputOTPGroup, InputOTPSlot } from "../input/InputOTP";
import ModaRedirect from "../simulador-economia/_components/ModaRedirect";
import { Button } from "../ui/button";
import { Checkbox } from "../ui/checkbox";
import { Label } from "../ui/label";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { Slider } from "../ui/slider";
import { useParams } from "react-router-dom";
import {
  maskCpfOrCnpj,
  normalizeCellphone,
  normalizeCNPJ,
  normalizeCPF,
} from "../../utils/inputMasks";
import { verificarTipoPessoa } from "../../utils/verificarTipoPessoa";
import { trackGa4 } from "../../utils/gtag";
import { getAgentePayload } from "../../utils/getAgentePayload";
import { ScoreLoading } from "../ScoreLoading/ScoreLoading";
import PoliticasModal from "../Footer/PoliticasModal";

export default function SimuladorEconomiaNovoFluxo() {
  const isMobile = window && window.innerWidth < 768;
  // const device = useDevice();

  const [openModalRedirectAquisition, setOpenModalRedirectAquisition] =
    useState(false);
  const [calculoNaoFinalizado, setCalculoNaoFinalizado] = useState(false);
  const [openModalRedirect, setOpenModalRedirect] = useState(false);
  const [uiStep, setUiStep] = useState("form"); // "form" | "score" | "result"
  const [loadingSimulacao, setLoadingSimulacao] = useState(false);
  const [loadingScore, setLoadingScore] = useState(false);
  const [loadingRedirect, setLoadingRedirect] = useState(false);
  const [isPoliticaModalOpen, setIsPoliticaModalOpen] = useState(false);
  const [politicaAceita, setPoliticaAceita] = useState(false);

  const [showModalNaoTemosOferta, setShowModalNaoTemosOferta] = useState(false);
  const [showModalSemOfertaDistribuidora, setShowModalSemOfertaDistribuidora] = useState(false)
  const [distribuidoraSelecionada, setDistribuidoraSelecionada] = useState("");
  const [valorEconomiaMensal, setValorEconomiaMensal] = useState(0);
  const [valorEconomiaAnual, setValorEconomiaAnual] = useState(0);
  const [clienteCadastradoModal, setClienteCadastradoModal] = useState(false);
  const [clienteNovoToken, setClienteNovoToken] = useState(false);
  const [showNovoClienteInfo, setShowNovoClienteInfo] = useState(false);
  const [thumbColor, setThumbColor] = useState("bg-claro-red");
  const [optComunicacao, setOptComunicacao] = useState(false);
  const [distribuidoras, setDistribuidoras] = useState([]);
  const [fingerprint, setFingerprint] = useState({});
  const [mediaGasto, setMediaGasto] = useState(0);
  const [urlParams, setUrlParams] = useState(null);
  const [telefone, setTelefone] = useState("");
  const [documento, setDocumento] = useState("");

  //OTP STATES
  const [OTPCode, setOTPCode] = useState("");
  const [validacaoTokenError, setValidacaoTokenError] = useState(false);
  const [hash, setHash] = useState("");

  const [utm, setUtm] = useState(null);

  const [simulationData, setSimulationData] = useState({});


  const isFormValid = telefone && distribuidoraSelecionada && mediaGasto > 0;

  const { token: tokenParam } = useParams();
  const tokenFromQuery = new URLSearchParams(window.location.search).get("token");
  const tokenClaro = tokenParam || tokenFromQuery || "";


  useEffect(()=> {
    if(!tokenClaro) return

    (async () => {
      try {
        const data = await obterPreCadastroPorTokenClaro(tokenClaro);
        const ent = data?.entities || null;

        handleDocumentoChange(normalizeCNPJ(ent?.cnpj) || normalizeCPF(ent.cpf) )
        handleTelefoneChange(
          ent?.telefone ||
          ent?.celular ||
          ent?.telefoneCelular ||
          ent?.phoneNumber ||
          ent?.mobile ||
          ""
        )

      } catch (e) {
        console.error("Falha ao pré-preencher por tokenClaro:", e);
      } finally {
      }
    })();

  }, [])

  useEffect(() => {
    const fetchFingerprint = async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();

      setFingerprint({
        idVisitor: result.visitorId,
        componentes: {
          dateTimeLocale: result.components.dateTimeLocale,
          platform: result.components.platform,
          vendor: result.components.vendor,
          vendorFlavors: result.components.vendorFlavors,
          timezone: result.components.timezone,
        },
      });
    };

    fetchFingerprint();
  }, []);

  useEffect(() => {
    async function fetchDistribuidoras() {
      const resp = await listDistribuidoras();
      const uniq = Array.from(
        new Map(
          (resp.entities || []).map((d) => [String(d.idDistribuidora), d])
        ).values()
      );
      setDistribuidoras(uniq);
    }
    fetchDistribuidoras();
  }, []);

  useEffect(() => {
    const utm = {
      utmId: getQueryParams("utm_id"),
      utmSource: getQueryParams("utm_source"),
      UtmMedium: getQueryParams("utm_medium"),
      UtmCampaign: getQueryParams("utm_campaign"),
      UtmSourcePlatform: getQueryParams("utm_source_platform"),
      UtmTerm: getQueryParams("utm_term"),
      UtmContent: getQueryParams("utm_content"),
    };
    setUtm(utm);
  }, []);

  useEffect(() => {
    const urlParams = `utm_source=${utm?.utmSource}&utm_medium=${utm?.UtmMedium}&utm_campaign=${utm?.UtmCampaign}&utm_id=${utm?.utmId}`;
    if (utm?.utmSource) {
      setUrlParams(urlParams);
    } else {
      setUrlParams(null);
    }
  }, [utm]);

  const getQueryParams = (paramName) => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(paramName);
  };

  const handleTelefoneChange = (value) => {
    setTelefone(value);
  };

  const handleDocumentoChange = (value) => {
    setDocumento(value);
  };

  const handleClickLeft = () => {
    const novoValor = Math.max(mediaGasto - 50, 0);
    setMediaGasto(novoValor);
    setThumbColor("bg-claro-red");
  };

  const handleClickRight = () => {
    const novoValor = Math.min(mediaGasto + 50, 2050);
    setMediaGasto(novoValor);
    setThumbColor("bg-claro-red");
  };

  const handleRedirectToLogin = () => {
    const url = `${config.url.urlPortalLogin}`;
    window.location.href = url;
    setClienteCadastradoModal(false);
  };

  const handleNewClient = (async ()=> {
    setLoadingRedirect(true)
    await sendNextStep({hash: hash, situacao: "2"})
    await handleRedirectPortal()
    setLoadingRedirect(false)
    // setClienteNovoToken(true);
    // setShowNovoClienteInfo(true);
  })

  const handleRequestOtp = useCallback(
    async (preAuthToken, clienteNovo = false) => {
      try {
        await requestOtp({
          dispararSms: config.simulacao.dispararSms,
          preAuthToken: preAuthToken,
        });

        if (clienteNovo) {
          setClienteNovoToken(true);
          setShowNovoClienteInfo(true);
        } else {
          setClienteCadastradoModal(true);
          setShowNovoClienteInfo(false);
        }

        setValidacaoTokenError(false);
      } catch (error) {
        toast.error("Erro ao obter token. Por favor, tente novamente.");
        console.error("Error fetching token:", error);
      }
    },
    []
  );

  const handleSubmitToken = useCallback(
    async (token, preAuthToken) => {
      if (!token || token?.length !== 6) {
        toast.error("Token inválido. Por favor, verifique o código.");
        return;
      }
      try {
        const response = await verifyOtp({
          otp: token,
          preAuthToken: preAuthToken,
          dispararSms: config.simulacao.dispararSms,
        });

        if (response && response.entities) {
          if (response.entities.token) {
            setCookie("__ae_auth_partner", response.entities.token, 4.16e-2);
          }

          if (response.entities.hash) {
            setHash(response.entities.hash);
          }
        }

        setClienteCadastradoModal(false);

        // if (simulationData.situacao === "A") {
        //   setOpenModalRedirectLogin(true);
        // } else

        if (
          simulationData.situacao !== "A" &&
          simulationData.situacao !== "1"
        ) {
          setOpenModalRedirectAquisition(true);
        } else {
          setOpenModalRedirect(true);
        }
      } catch (error) {
        toast.error("Erro ao validar token. Por favor, tente novamente.");
        setValidacaoTokenError(true);
      }
    },
    [simulationData, setValidacaoTokenError]
  );

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const pollCreditScore = useCallback(async (scorePayload, options = {}) => {
    const {
      maxAttempts = 10,
      waitMs = 7000,
    } = options;

    let attempt = 0;

    while (attempt < maxAttempts) {
      attempt += 1;

      const resp = await consultaCreditScore(scorePayload);
      const classificacao = resp?.classificacaoScore;

      if (classificacao === "CS") {
        if (attempt >= maxAttempts) {
          return { status: "pending", classificacao, resp };
        }
        await sleep(waitMs);
        continue;
      }

      if (classificacao === "AA" || classificacao === "AM") {
        return { status: "approved", classificacao, resp };
      }

      return { status: "rejected", classificacao, resp };
    }

    return { status: "pending", classificacao: "CS", resp: null };
  }, []);

  const handleSimulateEconomy = useCallback(async () => {
    try {
      if (!isFormValid) return;

      setLoadingSimulacao(true);

      const apenasDigitos = documento.replace(/\D/g, "");
      const isCnpj = verificarTipoPessoa(apenasDigitos);

      const response = await simularEconomia({
        cpf: isCnpj ? null : apenasDigitos,
        cnpj: isCnpj ? apenasDigitos : null,
        idDistribuidora: distribuidoraSelecionada.toString(),
        valorConsumo: mediaGasto,
        origem: 6,
        telefone: telefone.replace(/\D/g, ""),
        dispararSms: config.simulacao.dispararSms,
        tipolead: isCnpj ? "J" : "F",
        tokenClaro: tokenClaro,
        ...getAgentePayload(),
      });

      if (response && response.entities) {
        const data = response.entities;

        if (distribuidoras.find(item => item.idDistribuidora == distribuidoraSelecionada)?.situacao != 'A') {
          setShowModalSemOfertaDistribuidora(true);
          setLoadingSimulacao(false);
          return;
        }        

        // regra atual
        if (mediaGasto < 250) {
          setShowModalNaoTemosOferta(true);
          setLoadingSimulacao(false);
          return;
        }

        // regra atual
        if (data?.plano === 0 && data?.mensagens !== "N/A") {
          setCalculoNaoFinalizado(true);
          setLoadingSimulacao(false);

          trackGa4("simulate_economy_success", {
            app_lead_id: data?.idLead ?? null,
          });

          return;
        }

        // regra atual
        if (data.situacao === "A") {
          setLoadingSimulacao(false);
          handleRedirectToLogin();
          return;
        }

        if (data.hash) setHash(data.hash);

        // salva resultado (MAS ainda não mostra)
       setValorEconomiaAnual(data.meses12);
        setValorEconomiaMensal(data.mes);
        setSimulationData({ ...data, telefone });

        // encerra loaders e vai direto pro resultado
        setLoadingSimulacao(false);
        setLoadingScore(false);

        // BYPASS SCORE (mantém o código abaixo intacto, mas não executa)
        setUiStep("result");
        return;

        // === SCORE ===
        // (fica aqui igual está, mas nunca mais roda por causa do return)
        try {
          setLoadingScore(true);

          const scorePayload = {
            origem: "CSPV",
            idLead: data?.idLead,
            documentId: apenasDigitos,
            idCanal: config.simulacao.idCanal,
            idTipoProduto: 1,
            valorProposta: mediaGasto,
          };

          const scoreResult = await pollCreditScore(scorePayload, { maxAttempts: 10 });

          setLoadingScore(false);

          if (scoreResult.status === "approved") {
            setUiStep("result");
            return;
          }

          if (scoreResult.status === "pending") {
            setUiStep("form");
            return;
          }

          setShowModalNaoTemosOferta(true);
          setUiStep("form");
          return;
        } catch (e) {
          setLoadingScore(false);
          setUiStep("form");
        }

          return;
        }

      setLoadingSimulacao(false);
    } catch (err) {
      setLoadingSimulacao(false);
    }
  }, [
    distribuidoraSelecionada,
    isFormValid,
    mediaGasto,
    telefone,
    documento,
    tokenClaro,
    pollCreditScore,
  ]);


  const handleRedirectPortal = useCallback(async () => {
    if (!hash) return;
    await sendNextStep({hash: hash, situacao: "3"})

    const baseUrl = `${config.url.urlPortal}/claro/aquisicao/${hash}`;
    const url = urlParams ? `${baseUrl}?${urlParams}` : baseUrl;
    window.open(url, "_blank", "noopener,noreferrer"); 

    setOpenModalRedirect(false);
  }, [hash, urlParams]);


  const handleResetCalculadora = () => {
    setLoadingSimulacao(false);
    setLoadingScore(false);
    setUiStep("form");

    setDistribuidoraSelecionada("");
    setMediaGasto(0);
    setTelefone("");
    setOptComunicacao(true);
  };

  useEffect(() => {
    if (!openModalRedirect) return;

    let current = 3;

    const intervalId = setInterval(() => {
      current -= 1;

      if (current === 0) {
        clearInterval(intervalId);
        handleRedirectPortal();
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [openModalRedirect, handleRedirectPortal]);

  const buttonDisableClasses =
    "p-1 bg-gray-400 rounded-full hover:opacity-60 transition-all duration-150 ease-linear w-[50px] h-[50px] flex items-center justify-center shrink-0";
  const buttonEnableClasses =
    "p-1 bg-claro-red rounded-full hover:opacity-60 transition-all duration-150 ease-linear w-[50px] h-[50px] flex items-center justify-center shrink-0";

  const enableLeftButton = mediaGasto > 0;
  const enableRightButton = mediaGasto < 2050;

  const setCookie = (name, value, days) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);

    const hostname = window.location.hostname;

    const isLocalhost =
      hostname === "localhost" || hostname === "127.0.0.1" || hostname === "";

    let domain = "";
    if (!isLocalhost) {
      const domainParts = hostname.split(".");
      if (domainParts.length >= 2) {
        const mainDomain = domainParts.slice(-3).join(".");
        domain = `; Domain=.${mainDomain}`;
      }
    }

    let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(
      value
    )}`;
    cookieString += `; expires=${expires.toUTCString()}`;
    cookieString += `; path=/`;
    cookieString += domain;

    if (!isLocalhost) {
      cookieString += `; Secure`; // Apenas HTTPS
      cookieString += `; SameSite=None`; // Permite cross-site para subdomínios
    } else {
      cookieString += `; SameSite=Lax`;
    }

    document.cookie = cookieString;
  };

  return (
    <div className="w-full lg:w-[500px] rounded-3xl bg-white p-8 max-sm:px-4">
      {uiStep === "form" ? (
        <form
          id="fsimulacao"
          className="flex flex-col gap-4 justify-center items-center"
        >
          <h4 className="text-center text-neutral-900 text-2xl font-bold">
            Um benefício exclusivo para os clientes Claro.
          </h4>
          <div className="text-center justify-center text-neutral-600 text-base font-normal leading-none">
            Economize até 15% na sua conta de energia, sem investimentos ou obras.
          </div>
          <div className="w-full space-y-2">
            <Label
              htmlFor="cnpj"
              className="w-full flex justify-start text-center text-base font-semibold leading-normal pb-2"
            >
            </Label>

            <InputMask
              className="flex h-12 w-full items-center justify-between whitespace-nowrap text-gray-500 rounded-2xl border border-input border-black bg-transparent px-4 py-7 text-lg shadow-sm placeholder:text-muted-foreground focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1 placeholder:text-sm md:placeholder:text-base"
              // mask='(__) _____-____'
              placeholder="CPF ou CNPJ do titular da conta de energia"
              type="documento"
              name="documento"
              id="input_cpf_cnpj"
              required
              autoComplete="off"
              value={maskCpfOrCnpj(documento)}
              onChange={(e) => {
                handleDocumentoChange(e.target.value);
              }}
            />
          </div>

          <div className="w-full space-y-2">
            <Label
              htmlFor="telefone"
              className="w-full flex justify-start text-center text-base font-semibold leading-normal pb-2"
            >
            </Label>

            <InputMask
              className="flex h-12 w-full items-center justify-between whitespace-nowrap text-gray-500 rounded-2xl border border-input border-black bg-transparent px-4 py-7 text-lg shadow-sm placeholder:text-muted-foreground focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1 placeholder:text-sm md:placeholder:text-base"
              placeholder="DDD Celular/Whatsapp (titular conta de energia)"
              type="tel"
              name="telefone"
              id="input_telefone"
              required
              autoComplete="off"
              value={normalizeCellphone(telefone)}
              onChange={(e) => {
                handleTelefoneChange(e.target.value);
              }}
            />
          </div>

          <div className="w-full space-y-2">
            <Label
              htmlFor="distribuidora"
              className="w-full flex justify-start text-center text-base font-semibold leading-normal pb-2"
            >
            </Label>
            <Select
              onValueChange={async (value) => {
                setDistribuidoraSelecionada(value);
              }}
              value={distribuidoraSelecionada}
              name="distribuidora"
              id="select_distrib"
            >
              <SelectTrigger className="w-full text-base md:text-lg [&_span]:text-sm md:[&_span]:text-base">
                <SelectValue className="" placeholder="Escolha entre as distribuidoras" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  {distribuidoras.map((distribuidora, index) => (
                    <SelectItem
                      key={index}
                      value={String(distribuidora?.idDistribuidora)}
                    >
                      {distribuidora?.nomeDistribuidora || "Distribuidora"}
                    </SelectItem>
                  ))}
                </SelectGroup>
              </SelectContent>
            </Select>
          </div>
          <p className="text-center text-neutral-600 text-lg font-semibold leading-[27px]">
            Média de gasto da sua conta
          </p>
          <div className="text-center justify-center text-neutral-600 text-base font-normal leading-none">
            Elegibilidade mínima de R$ 250,00
          </div>
          <div className="w-full flex justify-center items-center gap-3">
            <button
              className={cn(
                "disabled:opacity-50",
                enableLeftButton ? buttonEnableClasses : buttonDisableClasses
              )}
              onClick={handleClickLeft}
              disabled={!enableRightButton}
              type="button"
            >
              <ArrowLeftIcon size={28} className="text-white max-md:size-8" />
            </button>
            <Slider
              id="slider_valor"
              value={[mediaGasto]}
              onValueChange={(value) => {
                const novoValor = value[0];
                setMediaGasto(novoValor);
                setThumbColor("bg-claro-red");
              }}
              max={2050}
              min={0}
              step={50}
              thumbValue={mediaGasto}
              thumbColor={thumbColor}
              className="flex-1 mx-4 !disabled:opacity-50"
              endText="+ de R$ 2.000,00"
            />
            <button
              className={cn(
                "disabled:opacity-50",
                enableRightButton ? buttonEnableClasses : buttonDisableClasses
              )}
              onClick={handleClickRight}
              disabled={!enableRightButton}
              type="button"
            >
              <ArrowRightIcon size={28} className="text-white max-md:size-8" />
            </button>
          </div>
          <div className="w-full flex justify-between items-center gap-2 px-5">
            <div className="text-center text-gray-500 text-sm font-bold">
              R$ 0,00
            </div>
            <div className="text-center text-gray-500 text-sm font-bold">
              R$ 2.000,00 ou +
            </div>
          </div>

          <div className="flex items-start space-x-2">
            <Checkbox
              id="optin_com"
              checked={optComunicacao}
              onCheckedChange={(checked) => setOptComunicacao(checked === true)}
              className="
                h-5 w-5 shrink-0 rounded-[4px]
                border-2 border-neutral-700
                p-0 leading-none
                flex items-center justify-center
                mt-1
                data-[state=checked]:border-[#DA291C]
                data-[state=checked]:bg-white
                data-[state=checked]:text-[#DA291C]
              "
            />
            <Label
              htmlFor="optin_com"
              className="text-sm font-normal text-black text-left"
            >
              Aceito receber comunicações do Claro Energia e confirmo que li e estou de acordo com<span className="inline-block border-b border-white/40 px-2">
                  <button
                   type="button"
                    className="text-claro-red hover:underline text-sm"
                    onClick={() => setIsPoliticaModalOpen(true)}
                  >Aviso de Privacidade</button>
                </span>
            </Label>
          </div>

          <div className="w-full">
            <Button
              id="click_simule"
              type="button"
              variant="primary"
              size="lg"
              className="!bg-claro-red !text-white w-full !rounded-full opacity-100 hover:!bg-claro-red"
              style={{ backgroundColor: "#DA291C", color: "white", opacity: 1 }}
              disabled={!isFormValid || loadingSimulacao || !optComunicacao}
              onClick={handleSimulateEconomy}
            >
              {loadingSimulacao ? (
                <>
                  <LoaderIcon size={18} className="mr-2 animate-spin text-white" />
                  Calculando
                </>
              ) : (
                "Simule agora"
              )}
            </Button>
          </div>
        </form>
      ) : uiStep === "score" ? (
            <ScoreLoading />
          ) : (
            <div
              id="boxResposta"
              className="flex flex-col gap-6 justify-center items-center"
            >
              <>
                <div className="w-full flex flex-col justify-center items-center gap-7 my-4">
                  <h4 className="text-center font-bold text-neutral-900 text-2xl leading-[52.80px] mb-2">
                    Você pode ter
                  </h4>

                  <div className="w-full flex flex-col justify-center items-center space-y-2">
                    <p className="font-bold text-3xl md:text-4xl text-color-black">
                      {valorEconomiaAnual.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </p>
                    <p>Economia estimada anual</p>
                  </div>

                  <div className="w-full flex flex-col justify-center items-center space-y-2">
                    <p className="font-bold text-3xl md:text-4xl text-color-black">
                      {valorEconomiaMensal.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </p>
                    <p>Economia estimada mensal</p>
                  </div>
                </div>
                <div className="w-full h-px border-b border-gray-200 my-4" />
                <div className="w-full flex max-md:flex-wrap gap-4 items-center justify-center">
                  <Button
                    id="click_aceito"
                    type="button"
                    variant="primary"
                    size="lg"
                    className="bg-claro-red text-bb-white w-[264px] lg:w-[332px] rounded-[4px] disabled:text-gray-300 "
                    onClick={handleNewClient}
                  >
                      {loadingRedirect ? (
                        <>
                          <LoaderIcon size={18} className="mr-2 animate-spin text-white" />
                          Carregando...
                        </>
                      ) : (
                        "Economize já"
                      )}
                  </Button>
                  {/* <AppButton
                      fullWidth
                      blueVariantborder
                      textButton='Refazer simulação'
                      onClick={() => setUiStep("form")}
                      id='CTA_refazer_01'
                    /> */}
                </div>
              </>
            </div>
      )}

      {/* Modal para redirecionamento caso o usuário tenha abandonado/caído da aquisição */}
      <ModaRedirect
        isOpen={openModalRedirectAquisition}
        onClose={() => {
          setOpenModalRedirectAquisition(false);
          setUiStep("form");
        }}
      >
        <div className="flex flex-col h-[100vh] items-start justify-end md:justify-center">
          <div className="relative flex flex-col items-center justify-center w-[100vw] md:w-[440px] mx-auto bg-white border rounded-t-3xl md:rounded-2xl py-10 px-6">
            <button
              className="absolute top-4 right-4 text-black"
              onClick={() => {
                setOpenModalRedirectAquisition(false);
                setUiStep("form");
              }}
              type="button"
            >
              <FaTimes className="w-6 h-6" />
            </button>
            <MdOutlineOpenInNew size={50} color="red" />
            <p className="text-xl text-center font-medium px-4 mt-3 mb-10">
              Bem-vindo de volta. Vamos redirecioná-lo para a página onde você
              parou.
            </p>
            <div className="w-full flex justify-center">
              <AppButton
                type="button"
                modalVariant
                fullWidth
                textButton="Entendi"
                onClick={() => handleRedirectPortal()}
              />
            </div>
          </div>
        </div>
      </ModaRedirect>

      {/* Modal de calculo não finalizado */}
      <ModaRedirect
        isOpen={calculoNaoFinalizado}
        onClose={() => {
          setCalculoNaoFinalizado(false);
          setDistribuidoraSelecionada("");
          setMediaGasto(0);
          setTelefone("");
          setOptComunicacao(true);
        }}
      >
        <div className="flex flex-col h-[100vh] items-start justify-end md:justify-center">
          <div className="relative flex flex-col items-center justify-center w-[100vw] md:w-[440px] mx-auto bg-white border rounded-t-3xl md:rounded-2xl py-10 px-6">
            <button
              className="absolute top-4 right-4 text-black"
              onClick={() => {
                setCalculoNaoFinalizado(false);
                setDistribuidoraSelecionada("");
                setMediaGasto(0);
                setTelefone("");
                setOptComunicacao(true);
              }}
              type="button"
              aria-label="Close modal"
            >
              <FaTimes className="w-6 h-6" />
            </button>
            <XIcon size={50} className="text-red-500" />
            <p className="text-xl text-center font-medium px-4 mt-3">
              Não foi possível realizar a sua simulação.
            </p>
            <p className="text-base text-center px-4 my-5">
              Tente acessar mais tarde
            </p>

            <div className="w-full flex justify-center">
              <AppButton
                fullWidth={isMobile}
                textButton="Entendi"
                type="button"
                onClick={() => {
                  setCalculoNaoFinalizado(false);
                  setDistribuidoraSelecionada("");
                  setMediaGasto(0);
                  setTelefone("");
                  setOptComunicacao(true);
                }}
              />
            </div>
          </div>
        </div>
      </ModaRedirect>

      <ModaRedirect isOpen={showModalSemOfertaDistribuidora}>
      <div className="flex h-[100vh] flex-col items-start justify-end md:justify-center">
        <div className="relative mx-auto flex w-[100vw] flex-col items-center justify-center rounded-t-3xl border bg-white px-6 py-10 md:w-[440px] md:rounded-2xl">
          <XIcon size={50} className="text-red-500" />

          <p className="mt-3 px-4 text-center text-xl font-medium">
            Não há oferta disponível no momento.
          </p>

          <p className="my-5 px-4 text-center text-base">
            Não se preocupe, entraremos em contato caso surja uma oportunidade.
          </p>

          <div className="flex w-full flex-col items-center justify-center gap-4">
            <AppButton
              fullWidth
              type="button"
              textButton="Entendi"
              className="!bg-claro-red !text-white h-[52px] w-full !rounded-full opacity-100 hover:!bg-claro-red"
              onClick={() => {
                const aEl = document.createElement("a");
                aEl.href = config.url.urlLp;
                aEl.click();
                setShowModalSemOfertaDistribuidora(false);
                handleResetCalculadora();
              }}
            />

            <AppButton
              fullWidth
              secondary
              type="button"
              textButton="Refazer simulação"
              onClick={() => {
                setShowModalSemOfertaDistribuidora(false);
                handleResetCalculadora();
              }}
              id="CTA_refazer_distribuidora_sem_oferta"
            />
          </div>
        </div>
      </div>
    </ModaRedirect>      

      {/* Modal de não temos uma oferta */}
      <ModaRedirect isOpen={showModalNaoTemosOferta}>
        <div className="flex flex-col h-[100vh] items-start justify-end md:justify-center">
          <div className="relative flex flex-col items-center justify-center w-[100vw] md:w-[440px] mx-auto bg-white border rounded-t-3xl md:rounded-2xl py-10 px-6">
            <XIcon size={50} className="text-red-500" />
            <p className="text-xl text-center font-medium px-4 mt-3">
              Ainda não temos uma oferta para você.
            </p>
            <p className="text-base text-center px-4 my-5">
              O benefício não está disponível para o seu perfil mensal de
              consumo. Entraremos em contato assim que tivermos uma
              oportunidade.
            </p>
            <div className="w-full flex flex-col justify-center items-center gap-4">
              <AppButton
                fullWidth
                type="button"
                textButton="Entendi"
                className="!bg-claro-red !text-white w-full !rounded-full opacity-100 hover:!bg-claro-red h-[52px]"
                onClick={() => {
                  const aEl = document.createElement("a");
                  aEl.href = config.url.urlLp;
                  aEl.click();
                  setShowModalNaoTemosOferta(false);
                  handleResetCalculadora();
                }}
              />
              <AppButton
                fullWidth
                secondary
                type="button"
                textButton="Refazer simulação"
                onClick={() => {
                  setShowModalNaoTemosOferta(false);
                  handleResetCalculadora();
                }}
                id="CTA_refazer_02"
              />
            </div>
          </div>
        </div>
      </ModaRedirect>

    <ModaRedirect
      isOpen={clienteCadastradoModal || clienteNovoToken}
      onClose={() => {
        setClienteCadastradoModal(false);
        setClienteNovoToken(false);
        setShowNovoClienteInfo(false);
        setOTPCode("");
        setValidacaoTokenError(false);
      }}
    >
      <div className="flex flex-col md:h-auto h-screen items-start justify-end md:justify-center">
        <div
          className={cn(
            "relative flex flex-col items-center justify-center w-[100vw] mx-auto bg-white border rounded-t-3xl md:rounded-2xl py-10 px-6",
            clienteNovoToken && showNovoClienteInfo
              ? "md:w-[640px]" // PASSO 1
              : "md:w-[440px]" // PASSO 2 (padrão atual)
          )}
        >
          <button
            className="absolute top-4 right-4 text-black"
            onClick={() => {
              setClienteCadastradoModal(false);
              setClienteNovoToken(false);
              setShowNovoClienteInfo(false);
              setOTPCode("");
              setValidacaoTokenError(false);
            }}
            type="button"
          >
            <FaTimes className="w-6 h-6" />
          </button>

          {clienteNovoToken && showNovoClienteInfo ? (
            // === PASSO 1 – TELA DA IMAGEM ===
            <div className="flex flex-col items-center mt-3 gap-6">
              <MdWarningAmber size={50} color="red" />
              <h1 className="self-stretch text-center justify-start text-black text-3xl font-extrabold leading-7">Você é o titular da conta de energia?</h1>

              <div className="text-sm text-center text-neutral-600 space-y-2 px-4">
                <p className="self-stretch text-center justify-center">
                  <span class="text-black text-xl font-light font-['Inter'] leading-6 tracking-tight">Por questões legais,</span><span class="text-black text-xl font-bold font-['Inter'] leading-6 tracking-tight"> <br/>precisamos dos dados do titular da conta de energia</span><span class="text-black text-xl font-light font-['Inter'] leading-6 tracking-tight"> e tudo bem se não for você, certifique-se de ter os dados do titular em mãos.</span>
                </p>
                <div className="self-stretch text-center justify-start text-stone-500 text-base font-normal font-['Inter'] leading-5">Por favor, providencie arquivos .JPEG, .PNG ou .PDF da CNH ou RG do titular da conta e a fatura de energia. No caso de empresa, CNH ou RG do responsável legal titular da conta da empresa e o contrato social ou o cartão CNPJ.<br/><br/>Caso não possua todas as informações em mãos, volte quando as tiver, esperamos por você.               
                </div>
              </div>

              <div className="w-full flex flex-col gap-3 mt-4">
                <Button
                  className="bg-claro-red text-white w-full rounded-full hover:opacity-90"
                  onClick={handleRedirectPortal}
                  id="vamos_prosseguir"
                  type="button"
                >
                  Ok, vamos prosseguir
                </Button>

                <Button
                  className="w-full rounded-full text-black border border-black"
                  onClick={() => {
                    setClienteNovoToken(false);
                    setShowNovoClienteInfo(false);
                    setUiStep("form");
                  }}
                  id="nao_prosseguir"
                  type="button"
                >
                  Não possuo todas as informações
                </Button>
              </div>
            </div>
          ) : (
            // === PASSO 2 – TOKEN (COMPORTAMENTO ATUAL) ===
            <>
              <MdOutlineOpenInNew size={50} color="red" />
              <div className="flex flex-col justify-center items-center mt-3">
                {clienteCadastradoModal && (
                  <p className="text-xl text-center font-medium px-4">
                    Você já está cadastrado.
                  </p>
                )}
                <p className="text-xl text-center font-medium px-4 mt-3 mb-10">
                  Um código de verificação foi enviado para o seu telefone.
                </p>

                <div>
                  <InputOTP
                    maxLength={6}
                    pattern={REGEXP_ONLY_DIGITS_AND_CHARS}
                    onChange={(value) => {
                      setOTPCode(value);
                    }}
                    value={OTPCode}
                    className="w-full"
                  >
                    <InputOTPGroup>
                      <InputOTPSlot
                        index={0}
                        className={cn(validacaoTokenError && "border-red-400")}
                      />
                      <InputOTPSlot
                        index={1}
                        className={cn(validacaoTokenError && "border-red-400")}
                      />
                      <InputOTPSlot
                        index={2}
                        className={cn(validacaoTokenError && "border-red-400")}
                      />
                      <InputOTPSlot
                        index={3}
                        className={cn(validacaoTokenError && "border-red-400")}
                      />
                      <InputOTPSlot
                        index={4}
                        className={cn(validacaoTokenError && "border-red-400")}
                      />
                      <InputOTPSlot
                        index={5}
                        className={cn(validacaoTokenError && "border-red-400")}
                      />
                    </InputOTPGroup>
                  </InputOTP>
                </div>

                <button
                  className="text-sm text-center font-normal text-gray-500 hover:opacity-60 border-b"
                  onClick={() => {
                    handleRequestOtp(
                      simulationData.preAuthToken,
                      clienteNovoToken // mantém se é novo ou não
                    );
                    setOTPCode("");
                  }}
                  type="button"
                >
                  Enviar novamente
                </button>

                <div className="w-full flex justify-center mt-4">
                  <Button
                    variant="primary"
                    size="lg"
                    className="bg-claro-red text-bb-white w-[264px] lg:w-[332px] rounded-[4px] disabled:text-gray-300  "
                    onClick={() =>
                      handleSubmitToken(OTPCode, simulationData.preAuthToken)
                    }
                    type="button"
                  >
                    Validar Token
                  </Button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </ModaRedirect>

      {/* Modal para redirecionamento para o portal do parceiro */}
      <ModaRedirect
        isOpen={openModalRedirect}
        onClose={() => setOpenModalRedirect(false)}
      >
        <div className="flex flex-col h-[100vh] items-start justify-end md:justify-center">
          <div className="relative flex flex-col items-center justify-center w-[100vw] md:w-[440px] mx-auto bg-white border rounded-t-3xl md:rounded-2xl py-10 px-6">
            <button
              className="absolute top-4 right-4 text-black"
              onClick={() => setOpenModalRedirect(false)}
              type="button"
            >
              <FaTimes className="w-6 h-6" />
            </button>
            <MdOutlineOpenInNew size={50} color="red" />
            <p className="text-xl text-center font-medium px-4 mt-3 mb-10">
              Você será direcionado para o portal Claro.
            </p>
            {/* <div className='w-full flex justify-center'>
              <AppButton
                modalVariant
                fullWidth
                textButton={loadingRedirect ? 'Carregando...' : 'Entendi'}
                onClick={() => handleRedirectPortal()}
              />
            </div> */}
          </div>
        </div>
      </ModaRedirect>
      <PoliticasModal
        isOpen={isPoliticaModalOpen}
        titulo="AVISO DE PRIVACIDADE DO CLARO ENERGIA"
        tipo="politicas"
        onClose={() => {
          setIsPoliticaModalOpen(false);
          const politicaStorage = localStorage.getItem("politica_aceita");
          const aceitos = politicaStorage === "TXT_POLITICAS_LIDO";
          setPoliticaAceita(aceitos);
        }}
      />       
    </div>
  );
}
